// extracted by mini-css-extract-plugin
export var container = "_6e-0";
export var disabled = "_6e-4";
export var fullWidth = "_6e-3";
export var lined = "_6e-1";
export var selected = "_6e-5";
export var tab = "_6e-2";